<template>
    <div class="project">

        <div class="projectImage">
            <polaroid-pic :imgFile="this.imgFile"></polaroid-pic>
        </div>
        <div class="details">
            <h4 class="title">{{ this.title }}</h4>
            <div class="projectImage">
                <polaroid-pic :imgFile="this.imgFile"></polaroid-pic>
            </div>
            <p class="synopsis">{{ this.synopsis }}</p>
            <div class="options">
                <filter-tag-button v-for="tag in tags" :title="tag"
                    v-bind:class="[{ selected: selectedTags.includes(tag) }, `tag`]" :key="tag"></filter-tag-button>
            </div>

        </div>

    </div>

</template>

<script>
export default {
    data() { },
    props: {
        title: String,
        synopsis: String,
        imgFile: String,
        link: String,
        tags: Array,
        selectedTags: Array,
    },
}
</script>

<style>
/* Project Styles */
.project {
    /* style */
    background-color: rgba(240, 255, 255, 0.25);
    box-shadow: 0 0 16px 0 rgba(85, 38, 38, 0.4);
    border-radius: 15px;
    /* organization */
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    /* spacing */
    padding: 30px;
    margin-bottom: 15px;
}

.project .projectImage {
    width: 25%;
}

.project .details {
    /* size */
    width: 65%;
    /* organization */
    display: flex;
    align-items: start;
    justify-content: space-between;
    flex-direction: column;
}

.project .details .title {
    text-align: start;
    font-family: "typeBld";
    font-size: 34px;
    margin-bottom: 30px;
}

.project .details .projectImage {
    display: none;
}

.project .details .synopsis {
    font-size: 16px;
    line-height: 22px;
}

.project .details .options {
    align-self: flex-end;
    display: flex;
    justify-content: end;
    width: 100%;
}

.project .details .options .tag {
    font-size: 16px;
    margin-left: 2%;
}

.project:hover {
    background-color: rgba(240, 255, 255, 0.35);
    box-shadow: 0 0 35px 0 rgba(85, 38, 38, 0.8);
}

/* Small Screen Desktop */
@media only screen and (max-width: 1600px) {
    .project .details .options .tag {
        font-size: 1vw;
    }
}

/* Tablet */
@media only screen and (max-width: 915px) {
    .project .details .options .tag {
        font-size: 2vw;
    }
}

/* Mobile */
@media only screen and (max-width: 560px) {
    .project {
        /* spacing */
        padding: 15px;
        margin-bottom: 15px;
    }

    .project .projectImage {
        display: none;
    }

    .project .details {
        width: 100%;
        padding: 0 15px;
    }

    .project .details .title {
        margin-bottom: 0px;
        white-space: nowrap;
    }

    .project .details .projectImage {
        display: inline;
        width: 100%;
        margin: 15px 0;
    }

    .project .details .options {
        flex-wrap: wrap;
    }

    .project .details .options .tag {
        font-size: 2.5vw;
        margin-bottom: 5px;
    }
}

/* END Project Styles */
</style>